<template>
  <div id="file">
    <span>{{ name }}</span>
    <span class="size">{{ bytesToSize(size) }}</span>
    <img
      @click.stop="remove(name)"
      src="@/assets/img/delete.svg"
      alt="Delete"
      title="Remove file"
    />
  </div>
</template>

<script>
export default {
  name: "File",
  props: {
    name: String,
    size: Number,
  },
  methods: {
    bytesToSize(bytes) {
      var sizes = ["Bytes", "KB", "MB", "GB", "TB"];
      if (bytes == 0) return "0 Byte";
      var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
      return Math.round(bytes / Math.pow(1024, i), 2) + " " + sizes[i];
    },
    remove(name) {
      this.$emit("remove", name);
    },
  },
};
</script>

<style scoped>
#file {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: #ffffff;
  border: 1px solid #d0d9e1;
  border-radius: 20px;
  padding: 6px 12px;
  margin: 4px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  transition: box-shadow 0.2s ease, border-color 0.2s ease;
  max-width: 220px;
}

#file:hover {
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.12);
  border-color: #66aee7;
}

#file span:first-child {
  font-size: 12px;
  font-weight: 600;
  color: #2c3e50;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 110px;
}

.size {
  color: #8899a6;
  font-weight: 500;
  font-size: 11px;
  white-space: nowrap;
  flex-shrink: 0;
}

img {
  height: 14px;
  width: 14px;
  cursor: pointer;
  z-index: 10;
  flex-shrink: 0;
  opacity: 0.6;
  transition: opacity 0.2s ease, transform 0.15s ease;
}

img:hover {
  opacity: 1;
  transform: scale(1.15);
}
</style>
